import React from 'react';
import Stack from '@mui/material/Stack';

import { VpHookFormColorInput, VpHookFormSelect, VpConditionalUpgradeWrapper } from '../..';
import { useFetchPluginById } from '../../../hooks';
import { PLUGIN_TYPES } from '../../../constants/plugin-types';

const AUTOPLAY_OPTIONS = [
  { id: true, label: 'ON' },
  { id: false, label: 'OFF' }
];

const createOptions = (start, end) =>
  Array.from({ length: end + 1 - start }, (x, i) => `${i + start}`);

export const VpPluginCardInputs = () => {
  const { data } = useFetchPluginById();

  const pluginType = data?.type;

  const renderFirstInput = (isDisabled) => {
    if (pluginType === PLUGIN_TYPES?.GALLERY) {
      return null;
    }

    if (pluginType === PLUGIN_TYPES?.PLAYLIST) {
      return (
        <VpHookFormSelect
          disableHelperText
          name="autoplay"
          label="Autoplay"
          options={AUTOPLAY_OPTIONS}
          defaultValue={data?.styles.autoplay}
          smallLabel
          disabled={isDisabled}
          selectDefault
        />
      );
    }

    if (pluginType === PLUGIN_TYPES?.LIST) {
      return (
        <VpHookFormSelect
          disableHelperText
          required
          name="numOfCards"
          label="ROWS"
          options={createOptions(1, 10)}
          defaultValue={data?.styles.numOfCards}
          smallLabel
          disabled={isDisabled}
          selectDefault
        />
      );
    }

    return (
      <VpHookFormSelect
        disableHelperText
        required
        name="numOfCards"
        label="CARDS"
        options={createOptions(2, 4)}
        defaultValue={data?.styles.numOfCards}
        smallLabel
        disabled={isDisabled}
        selectDefault
      />
    );
  };

  return (
    <VpConditionalUpgradeWrapper featureKey="PLUGIN_STYLES_EDITING_ENABLED">
      {({ isDisabled }) => (
        <Stack direction="row" alignItems="end" spacing={1}>
          {renderFirstInput()}
          <VpHookFormColorInput
            required
            label="BACKGROUND COLOR"
            name="backgroundColor"
            disableHelperText
            defaultValue={data?.styles?.backgroundColor}
            smallLabel
            disabled={isDisabled || pluginType === PLUGIN_TYPES?.PLAYLIST}
          />
          <VpHookFormColorInput
            required
            label="PRIMARY COLOR"
            name="primaryColor"
            disableHelperText
            defaultValue={data?.styles.primaryColor}
            smallLabel
            disabled={isDisabled}
          />
        </Stack>
      )}
    </VpConditionalUpgradeWrapper>
  );
};

export default VpPluginCardInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginCardInputs.jsx